import React, { useEffect, useState } from 'react';
import * as S from './estilos';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import ReactHtmlParser from 'react-html-parser';
import useData from '../../Utils/useData/index';
import Load from '../Load';

import ImgBolas from '../../Images/ImgBolas.jpg';
import ImgBolasResp from '../../Images/ImgBolasResp.jpg';
import ImgRiscoVermelho from '../../Images/ImgRiscoVermelho.png';

import ImgCasa1 from '../../Images/Diferenciais/Banner1.jpg';
import ImgCasa1Resp from '../../Images/Diferenciais/Banner1Resp.jpg';
import ImgCasa2 from '../../Images/Diferenciais/Banner2.jpg';
import ImgCasa2Resp from '../../Images/Diferenciais/Banner2Resp.jpg';
import ImgCasa3 from '../../Images/Diferenciais/Banner3.jpg';
import ImgCasa3Resp from '../../Images/Diferenciais/Banner3Resp.jpg';
import ImgCasa4 from '../../Images/Diferenciais/Banner4.jpg';
import ImgCasa4Resp from '../../Images/Diferenciais/Banner4Resp.jpg';

function Casa() {
  const [data, setData] = useState<any>([]);
  const [load, setLoad] = useState(false);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const loadData = () => {
    useData()
      .getData('/api/casa.php')
      .then((response: any) => {
        setData(response);
      })
      .catch((err) => {
        console.info(err);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      loadData();
    }, 1000);
  }, []);

  return (
    <>
      {/* {load == true && <Load status={load} colorPrimary={'#c73127'} colorSecondary={'#b9b9b9'} />} */}

      <div className='Ancora' id='Casa'></div>
      <S.ForaCasa>
        <S.ImagemBolas src={ImgBolas} />
        <S.ImagemBolasResp src={ImgBolasResp} />
        <S.CimaCasa>
          <S.ForaTextCasa1>
            <S.TextCasa1Resp>A casa</S.TextCasa1Resp>
            <S.TextCasa2Resp>Villa</S.TextCasa2Resp>
            <S.TextCasa2Resp>Country</S.TextCasa2Resp>
          </S.ForaTextCasa1>

          <S.ImagemRiscoVermelho src={ImgRiscoVermelho} />
          <S.ForaTextCasa2>
            {data &&
              data.map((data: any, index: React.Key | null | undefined) => (
                <S.TextCasa2 key={index}>{ReactHtmlParser(data.c_texto)}</S.TextCasa2>
              ))}
          </S.ForaTextCasa2>
        </S.CimaCasa>

        <S.TextDiferenciais>Diferenciais</S.TextDiferenciais>

        <Slider className='SliderCasa1' {...settings}>
          <S.ForaImgCasa1>
            <S.ImagemCasa1 src={ImgCasa1} />
          </S.ForaImgCasa1>
          <S.ForaImgCasa1>
            <S.ImagemCasa1 src={ImgCasa2} />
          </S.ForaImgCasa1>
          <S.ForaImgCasa1>
            <S.ImagemCasa1 src={ImgCasa3} />
          </S.ForaImgCasa1>
          <S.ForaImgCasa1>
            <S.ImagemCasa1 src={ImgCasa4} />
          </S.ForaImgCasa1>
        </Slider>

        <Slider className='SliderCasa2' {...settings}>
          <S.ForaImgCasa1Resp>
            <S.ImagemCasa1 src={ImgCasa1Resp} />
          </S.ForaImgCasa1Resp>
          <S.ForaImgCasa1Resp>
            <S.ImagemCasa1 src={ImgCasa2Resp} />
          </S.ForaImgCasa1Resp>
          <S.ForaImgCasa1Resp>
            <S.ImagemCasa1 src={ImgCasa3Resp} />
          </S.ForaImgCasa1Resp>
          <S.ForaImgCasa1Resp>
            <S.ImagemCasa1 src={ImgCasa4Resp} />
          </S.ForaImgCasa1Resp>
        </Slider>
      </S.ForaCasa>
    </>
  );
}

export default Casa;
